// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'

// mixins
import axios from 'axios'
import api from './mixins/api'
import dialog from './mixins/dialog'

// CSS
import './../node_modules/bulma/css/bulma.css'
import './../node_modules/@fortawesome/fontawesome-free/css/all.css'

// Components
import App from './App'
import Loading from './components/dialogs/Loading'
import Modal from './components/dialogs/Modal'
import NavBar from './components/navigation/NavBar'
import Confirm from './components/dialogs/Confirm'
import VueGoogleCharts from 'vue-google-charts'

// Global Vue and events
window.Vue = require('vue')
window.Event = new Vue()
Vue.config.productionTip = false

// Use mixins and components
Vue.use(api)
Vue.use(dialog)
Vue.component('loading', Loading)
Vue.component('modal', Modal)
Vue.component('nav-bar', NavBar)
Vue.component('confirm', Confirm)
Vue.use(VueGoogleCharts)

// Storage
Storage.prototype.setObject = function (key, value) {
  this.setItem(key, JSON.stringify(value))
}

Storage.prototype.getObject = function (key) {
  let value = this.getItem(key)
  return value && JSON.parse(value)
}

Storage.prototype.deleteObject = function (key) {
  this.removeItem(key)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js